<template>
  <li class="frisbuy-gallery-post pn-ad-post">
    <div class="frisbuy-post-image" @click="showPopup = true">
      <img :src="`${envDomain}/images/lassie/${adImageName}`" alt="Lassie" />
      <!-- <span class="frisbuy-post-image__text">
        Отмечайте
        <span class="frisbuy-post-image__text--host"> @lassie_russia </span>
        <br />
        в соцсетях или загружайте на сайте и ваши образы появятся здесь
      </span> -->
    </div>
    <div
      class="frisbuy-popup-overlay"
      @click="showPopup = false"
      v-if="showPopup"
    >
      <div
        :class="{ 'frisbuy-popup': true, 'frisbuy-scroller': true }"
        @click.stop
        ref="iuPopup"
      >
        <div class="frisbuy-popup-controls">
          <div class="frisbuy-popup-navigation">
            <div
              class="frisbuy-popup-control frisbuy-prev"
              @click="openPost(currentIndex - 1)"
            >
              <svg
                width="16.530331"
                height="13.06066"
                viewBox="0 0 16.530331 13.06066"
                version="1.1"
                id="svg4"
              >
                <path
                  d="M 6.5303301,0.53033009 0.53033009,6.5303301 m 0,0 L 6.5303301,12.53033 M 0.53033009,6.5303301 H 8.5303301 16.53033"
                  id="path2"
                />
              </svg>
            </div>
            <div
              class="frisbuy-popup-control frisbuy-next"
              @click="openPost(currentIndex + 1)"
            >
              <svg
                width="16.530331"
                height="13.06066"
                viewBox="0 0 16.530331 13.06066"
                version="1.1"
                id="svg4"
              >
                <path
                  d="M 6.5303301,0.53033009 0.53033009,6.5303301 m 0,0 L 6.5303301,12.53033 M 0.53033009,6.5303301 H 8.5303301 16.53033"
                  id="path2"
                />
              </svg>
            </div>
          </div>
          <div
            class="frisbuy-popup-control frisbuy-close"
            @click="showPopup = false"
          >
            <svg
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
            >
              <path
                d="M286.17,256L505.752,36.418c8.331-8.331,8.331-21.839,0-30.17c-8.331-8.331-21.839-8.331-30.17,0L256,225.83L36.418,6.248
			c-8.331-8.331-21.839-8.331-30.17,0c-8.331,8.331-8.331,21.839,0,30.17L225.83,256L6.248,475.582
			c-8.331,8.331-8.331,21.839,0,30.17c8.331,8.331,21.839,8.331,30.17,0L256,286.17l219.582,219.582
			c8.331,8.331,21.839,8.331,30.17,0c8.331-8.331,8.331-21.839,0-30.17L286.17,256z"
              />
            </svg>
          </div>
        </div>
        <div
          class="frisbuy-content-wrapper frisbuy-scroller"
          ref="scrollWrapper"
        >
          <div class="frisbuy-popup-content">
            <div class="frisbuy-popup-media">
              <img
                :src="`${envDomain}/images/lassie/${adImageName}`"
                alt="Lassie"
              />

              <!-- <span class="frisbuy-post-image__text">
                Отмечайте
                <span class="frisbuy-post-image__text--host">
                  @lassie_russia
                </span>
                в соцсетях или загружайте на сайте и ваши образы появятся здесь
              </span> -->
            </div>
          </div>
          <div class="frisbuy-popup-details">
            <div
              class="frisbuy-details-scroller frisbuy-scroller"
              ref="scrollDetails"
            >
              <div class="pn-ad-title">#LASSIEFAMILY</div>
              <div class="pn-ad-description">
                Делитесь стильными образами в соцсетях, отмечайте Lassie или
                загружайте фото прямо на сайте.
              </div>

              <div
                widget-iu-button="true"
                onclick="iuWidget.open()"
                class="frb-upload-button-all"
              >
                <div class="photo-conteiner">
                  <div class="photo"></div>
                </div>
                <div class="frb-upload-button-text">Добавьте свой образ</div>
              </div>

              <div class="pn-ad-divider"></div>
              <div class="pn-ad-hint">
                Все фото проходят модерацию, загружая фотографии, ты
                подтверждаешь согласие с нашими
                <a
                  target="_blank"
                  href="https://lassie.ru/about/obrabotka-personalnykh-dannykh/"
                  >правилами обработки персональных данных</a
                >.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
const bodyScrollLock = require("body-scroll-lock");

export default {
  data() {
    return {
      showPopup: false,
    };
  },

  props: ["settings", "currentIndex"],

  methods: {
    openPost(index) {
      this.showPopup = false;
      this.$emit("open-post", index);
    },
  },

  computed: {
    adImageName() {
      let imageName = "lassie-ad-v2--blue.jpeg";
      const windowPath = window.location.pathname;

      switch (windowPath) {
        case "/":
          imageName = "lassie-ad-v1--blue.jpeg";
          break;
        case "/about/galereya/":
          imageName = "lassie-ad-v1--blue.jpeg";
          break;
      }

      return imageName;
    },
  },

  watch: {
    showPopup(value) {
      this.$nextTick(() => {
        const { scrollWrapper } = this.$refs;

        if (value) {
          this.sendAnaliticEvent("Click_ad_post", window.location.href);
          bodyScrollLock.disableBodyScroll(scrollWrapper);
        } else {
          bodyScrollLock.clearAllBodyScrollLocks();
        }
      });
    },
  },
};
</script>

<style lang="scss">
.frisbuy-gallery-post.pn-ad-post {
  cursor: pointer;
  color: #2c2c2c;
  position: relative;
  flex-shrink: 0;

  .frisbuy-post-image {
    width: 100%;
    padding-bottom: 100%;

    & > img {
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }

  .pn-ad-title {
    font-family: Factor, sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: #333;
    text-transform: uppercase;

    margin-bottom: 20px;

    text-transform: uppercase;
  }

  .pn-ad-description {
    font-family: Factor, sans-serif;
    font-size: 14px;
    color: #333;
    text-align: left;
    margin-bottom: 24px;
  }

  .pn-ad-upload-button {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    margin-top: 40px;
    cursor: pointer;
  }

  .pn-ad-tag-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    margin-top: 16px;
    border-bottom: 1px solid #c0c0c0;
  }

  .pn-ad-divider {
    flex-grow: 1;
  }

  .pn-ad-hint {
    font-size: 12px;
    line-height: 18px;
  }

  .frisbuy-popup-media {
    width: 531px;

    & > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .frisbuy-details-scroller {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    a {
      text-decoration: none;
      color: inherit;
      border-bottom: 1px solid #c0c0c0;
    }
  }

  .frisbuy-popup .frisbuy-popup-details {
    padding-left: 24px;
  }

  .frisbuy-popup-details:after {
    display: none;
  }

  .frisbuy-popup-overlay {
    cursor: default;
  }

  .frisbuy-popup {
    padding: 51px;
  }

  .le-hash-copied {
    padding: 10px 61px;
    position: absolute;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-transform: uppercase;
    color: #2c2c2c;
    background: #ffffff;
    border: 1px solid #c0c0c0;
    border-radius: 56px;
    bottom: 10px;
    left: calc(50% - 141px);

    &.le-hash-enter-active {
      opacity: 0;
      transition: opacity 1s;
    }

    &.le-hash-enter-to {
      opacity: 1;
    }

    &.le-hash-leave-active {
      opacity: 1;
      transition: 1s opacity 3s;
    }

    &.le-hash-leave-to {
      opacity: 0;
    }
  }

  @media only screen and (max-width: 1199px) {
    .frisbuy-popup {
      padding: 10px;
    }

    .frisbuy-popup-media {
      width: 441px;
    }
  }

  @media only screen and (max-width: 767px) {
    .frisbuy-popup {
      padding: 0;
    }

    .frisbuy-popup-media {
      width: 100%;

      svg {
        position: absolute;
      }
    }

    .frisbuy-popup-details {
      padding: 0 30px;
    }

    .frisbuy-popup-controls {
      justify-content: flex-end !important;
    }

    .le-hash-copied {
      position: fixed;
    }
  }

  @media only screen and (max-width: 414px) {
    .frisbuy-popup-details {
      padding: 0;
    }
  }
}
</style>

<!-- styles for adv post text (onchange image) -->
<style scoped lang="scss">
.frisbuy-post-image,
.frisbuy-popup-media {
  background-color: #e0ebf8;
}

.frisbuy-popup-media {
  aspect-ratio: 1 / 1;
}

.frisbuy-post-image__text {
  display: block !important;
  position: absolute;
  inset: auto 0 0;

  color: #002354;

  font-family: Factor A Light, sans-serif;
  font-size: 18px;
  font-weight: 300;
  line-height: 25.2px;

  padding: 24px 31px;
  margin-top: auto;

  .frisbuy-post-image__text--host {
    display: inline;
    font-family: Factor A, sans-serif;
    font-size: 1em;
    font-weight: 400;
  }
}

@media (max-width: 1023px) {
  .frisbuy-post-image {
    .frisbuy-post-image__text {
      & {
        font-size: 14px;
        line-height: 18.2px;

        padding: 12px;
      }
    }
  }
}
</style>

<!-- TODO: refactor scoped styles to avoid copying them -->
<!-- copied from ../../lassie_infinity_images/popup/popup.vue -->
<style scoped lang="scss">
$lassiePrimaryColor: #002354;
$arrowButtonsWidth: 46px;

.frisbuy-popup-overlay {
  background-color: #{$lassiePrimaryColor}7d; // opacity 50%

  .frisbuy-popup {
    position: relative;
    padding: 0;

    max-width: 1184px;
    max-height: 676px;

    .frisbuy-popup-controls {
      display: flex;
      position: absolute;

      inset: 0;
      flex-direction: column;
      justify-content: center;

      width: calc(100% + ($arrowButtonsWidth * 2) + (16px * 2));
      transform: translateX(calc(-1 * ($arrowButtonsWidth + 16px)));

      pointer-events: none;

      z-index: 1;

      .frisbuy-popup-navigation {
        display: flex;
        justify-content: space-between;
      }

      .frisbuy-popup-control {
        &.frisbuy-prev,
        &.frisbuy-next,
        &.frisbuy-close {
          pointer-events: all;

          width: $arrowButtonsWidth;
          height: 48px;

          border: 1px solid $lassiePrimaryColor;
          background: #ffffff;

          svg {
            &,
            path {
              fill: $lassiePrimaryColor;
              stroke: $lassiePrimaryColor;
              stroke-width: 1.5;
            }
          }

          &:hover {
            border: 1px solid $lassiePrimaryColor;
            background: #ffffff;

            svg {
              &,
              path {
                fill: #667b98;
                stroke: #667b98;
              }
            }
          }
        }

        &.frisbuy-prev,
        &.frisbuy-next {
          position: relative;

          svg {
            width: 16px;
            height: 12px;
          }
        }

        &.frisbuy-close {
          transform: translateY(-50%);

          svg {
            width: 18px;
            height: 18px;
          }
        }
      }
    }

    .frisbuy-content-wrapper {
      padding: 32px;

      .frisbuy-popup-content {
        .frisbuy-popup-media {
          display: flex;
          flex-direction: column;

          width: 100%;
          max-width: 600px;
          aspect-ratio: 1 / 1;

          overflow: visible;

          .frisbuy-gallery-navigation {
            width: calc(100% + 48px); // 48px - width .frisbuy-navigation-button
            left: calc(-48px / 2);

            .frisbuy-navigation-button {
              width: 48px;
              height: 48px;

              transform: none;
              opacity: 1;
              box-shadow: 0px 0px 40px 0px #00235417;

              margin: 0;

              &:last-child {
                transform: scale(-1, 1);
              }

              svg {
                width: 22px;
                height: 16px;

                &,
                path {
                  fill: $lassiePrimaryColor;
                  stroke: $lassiePrimaryColor;
                  stroke-width: 1.5;
                }
              }

              &:hover {
                svg {
                  &,
                  path {
                    fill: #667b98;
                    stroke: #667b98;
                  }
                }
              }
            }
          }

          .frisbuy-gallery-pagination {
            position: relative;
            bottom: 0;

            height: fit-content;

            margin-top: 12px;

            .frisbuy-gallery-page {
              width: 100%;
              max-width: 40px;
              height: 2px;

              box-shadow: none;
              border-radius: none;

              background-color: #b8c2cf47;

              margin: 0;

              &:not(:first-child) {
                margin: 0 0 0 14px;
              }

              &.active {
                background-color: $lassiePrimaryColor;
              }
            }
          }
        }
      }

      .frisbuy-popup-details {
        padding-left: 32px;

        .frisbuy-details-scroller {
          padding-right: 0;

          .frisbuy-post-details {
            &,
            * {
              color: $lassiePrimaryColor;
              font-size: 16px;
            }

            svg {
              width: 100%;
              height: 100%;
            }

            a {
              margin: 0;
            }
          }

          .frisbuy-post-text {
            margin: 14px 0 0 0;
          }

          .frisbuy-products-list__title {
            margin-top: 24px;
            color: $lassiePrimaryColor;
            font-size: 16px;
            text-transform: uppercase;
          }

          .frisbuy-products-list {
            padding: 22px 0;
            margin-top: 12px;

            .frisbuy-product-item {
              display: flex;
              flex-direction: row;
              width: 100%;
              height: 160px;

              border-top: 1px solid #dee2e9;

              padding-top: 20px;
              margin: 0;

              &:not(:first-child) {
                margin: 20px 0 0 0;
              }

              .frisbuy-marker {
                border-color: $lassiePrimaryColor;
                color: $lassiePrimaryColor;

                &.frisbuy-marker-hover {
                  background-color: $lassiePrimaryColor;
                  color: #ffffff;
                }
              }

              .frisbuy-product-image {
                display: inline-block;
                width: 130px;
                height: 100%;
                background-size: cover;
                margin: 0;
              }

              .frisbuy-product-item__info {
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                flex-grow: 1;

                margin-left: 20px;

                * {
                  text-align: left;
                }

                .frisbuy-product-item__title {
                  color: $lassiePrimaryColor;
                  text-transform: uppercase;
                  font-size: 16px;

                  height: 69px;
                }

                .frisbuy-product-price {
                  display: inline-block;
                  vertical-align: middle;

                  color: $lassiePrimaryColor;
                  height: 20px;
                  font-family: inherit;
                  font-size: 18px;
                  font-weight: 400;

                  margin-top: 10px;

                  .frisbuy-price-old {
                    color: #5c6f83;
                    font-size: 0.7777778em;
                  }
                }

                .frisbuy-product-item__buy-button {
                  font-family: inherit;
                  color: #ffffff;
                  background-color: $lassiePrimaryColor;
                  border: 1px solid $lassiePrimaryColor;

                  width: fit-content;
                  height: fit-content;

                  text-transform: capitalize;

                  padding: 10px 32px;
                  margin-top: 16px;

                  &:hover {
                    color: $lassiePrimaryColor;
                    background-color: #ffffff;
                  }
                }
              }
            }
          }
        }

        &:after {
          display: none;
        }
      }
    }
  }
}

// media queries
@media only screen and (max-width: 1300px) {
  .frisbuy-popup-overlay {
    .frisbuy-popup {
      max-width: 951px;
      max-height: 543px;
    }
  }
}

@media only screen and (max-width: 1199px) {
  .frisbuy-popup-overlay {
    .frisbuy-popup {
      max-width: 850px;
      max-height: 485px;

      .frisbuy-popup-controls {
        align-items: unset;
        margin: unset;

        .frisbuy-popup-control {
          &.frisbuy-close {
            position: absolute;
          }
        }
      }

      .frisbuy-content-wrapper {
        height: 100%;
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .frisbuy-popup-overlay {
    .frisbuy-popup {
      max-width: 650px;
      max-height: 371px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .frisbuy-popup-overlay {
    .frisbuy-popup {
      max-width: 470px;
      max-height: 100%;

      .frisbuy-content-wrapper {
        padding: 8px 16px 0;

        height: calc(100% - 48px);

        .frisbuy-popup-content {
          .frisbuy-popup-media {
            .frisbuy-gallery-navigation {
              .frisbuy-navigation-button {
                display: none;
              }
            }
          }
        }

        .frisbuy-popup-details {
          padding-left: 0;
          margin-top: 24px;

          .frisbuy-details-scroller {
            .frisbuy-post-text {
              margin: 8px 0 0 0;
            }
          }
        }
      }

      .frisbuy-popup-controls {
        display: flex;
        position: static;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        transform: none;
        pointer-events: none;

        padding: 4px 0;

        .frisbuy-popup-navigation {
          justify-content: start;
        }

        .frisbuy-popup-control {
          &.frisbuy-prev,
          &.frisbuy-next,
          &.frisbuy-close {
            border: none;
            background: transparent;

            &:hover {
              border: none;
              background: transparent;
            }
          }

          &.frisbuy-prev,
          &.frisbuy-next {
            svg {
              width: 22px;
              height: 16px;
            }
          }

          &.frisbuy-prev {
            transform: none;
          }

          &.frisbuy-next {
            transform: scale(-1, 1);
          }

          &.frisbuy-close {
            position: relative;
            transform: none;
          }
        }
      }
    }

    .frisbuy-popup-details {
      padding: 0;
    }

    .frb-upload-button-all {
      min-width: 100%;
    }
  }
}
</style>
